import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-client-setting',
  templateUrl: './client-setting.component.html',
  styleUrls: ['./client-setting.component.scss']
})
export class ClientSettingComponent {
 tabs = [
    { key: 'notification', label: 'Notification Configuration', icon: 'pi pi-envelope' },
    { key: 'communication', label: 'Commincation Configuration', icon: 'pi pi-whatsapp' },
     { key: 'whatsapp', label: 'Whatsapp Configuration', icon: 'pi pi-whatsapp' },
    // { key: 'payment', label: 'Payment', icon: 'pi pi-credit-card' },
    // { key: 'sms', label: 'SMS', icon: 'pi pi-mobile' },
    // { key: 'general', label: 'General', icon: 'pi pi-cog' }
  ];

  currentTab = 'notification';

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
     this.route.paramMap.subscribe(params => {
    this.currentTab = params.get('tab') || 'notification'; // default tab
    console.log('Active tab:', this.currentTab);
  });
  }
  changeTab(t: string) {
    this.currentTab = t;
  }
}